import { createSelector } from "reselect";

import getFilter from "../base_getters/get_filter";

const getUniformatTrades = createSelector([
  getFilter
], (filter) => {
  return { ...filter.uniformat.level1, ...filter.uniformat.level2, ...filter.uniformat.level3, ...filter.uniformat.level4 };
});

export default getUniformatTrades;
